import { Alert, AlertColor, AlertTitle } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { AlertContainer } from '../clientconfigtool/ClientConfigToolStyles'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

type NotificationProps = {
  autoHide?: boolean
  severity: AlertColor
  title: string
  description?: string
  onClose?: () => void
}

function Notification(props: NotificationProps) {
  const { autoHide, description, onClose, title, severity } = props
  const [ hidden, setHidden ] = useState(false)
  const timeoutRef = useRef(null)
  // as closeAlert will be called from setTimeout and function passed to setTimeout gets cached, so to avoid it, using reference
  const closeAlertRef = useRef(() => null)

  closeAlertRef.current = onClose || (() => null)

  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }

  const closeAlert = () => {
    clearTimer()
    closeAlertRef.current()
    setHidden(true)
  }

  const autoHideAlert = () => {
    clearTimer()
    timeoutRef.current = setTimeout(closeAlert, 6000)
  }

  useEffect(() => {
    if (autoHide) {
      autoHideAlert()
    }
  }, [autoHide])

  return (
    !hidden
      ? (
        <AlertContainer>
          <Alert 
            data-testid="cct-alert"
            iconMapping={{
              success: <CheckCircleOutlineIcon fontSize="inherit" />,
            }}
            onClose={closeAlert}
            severity={severity}
            sx={{width: '42.82rem'}}
          >
            <AlertTitle>{title}</AlertTitle>
            {description || ''}
          </Alert>
        </AlertContainer>
      )
      : null
  )
}

export default Notification